import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivateFn } from '@angular/router';
import { UserService } from '../../../services/user/user';
import { environment } from '../../../../environments/environment';

/**
 * Guard to check if the current user has admin access
 */
export const adminGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);

  const currentUser = userService.currentUser();

  if (!currentUser) {
    router.navigate(['/profile']);
    return false;
  }

  // Check if user email is in admin whitelist
  const adminEmails = environment.adminEmails || [];
  const isAdmin = adminEmails.includes(currentUser.email);

  if (!isAdmin) {
    router.navigate(['/profile']);
    return false;
  }

  return true;
};
